import React from 'react';
import {withStyles, InputLabel} from "@material-ui/core";
import { themeTypeToBool } from './../../utils/helpers';

export default withStyles(theme => ({
    root: {
        fontSize: "0.65rem",
        color: themeTypeToBool(theme.palette.type) ? theme.palette.common.black : "#FAFAFA"
    },
    shrink: {
        transform: "translate(0, 1.5px)"
    }
}))(props => <InputLabel shrink={true} {...props} />);
